import { ArticleInTextTeaserTheme } from '@/components/ArticleInTextTeaser/theme';
import { ArticleTeaser } from '@/components/ArticleTeaser';
import { GenericSlot } from 'base/components/GenericSlot';

export const ArticleInTextTeaser = GenericSlot({ as: ArticleTeaser, theme: ArticleInTextTeaserTheme });
